import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M19.1 11.3q-.226-2.8-2.187-4.763Q14.95 4.575 12.15 4.35v-.7q1.55.1 2.9.725a8.2 8.2 0 0 1 2.375 1.65 8.2 8.2 0 0 1 1.65 2.375q.625 1.35.725 2.9zm-4 0a3.75 3.75 0 0 0-1.025-1.938A3.5 3.5 0 0 0 12.15 8.35v-.7q1.425.2 2.425 1.212A4.35 4.35 0 0 1 15.8 11.3zm3.525 8.4q-2.35 0-4.887-1.238Q11.2 17.224 8.975 15q-2.2-2.225-3.438-4.75T4.3 5.375q0-.45.3-.763.3-.312.75-.312h2q.426 0 .737.262.313.263.438.688l.45 2.05q.075.424-.025.75a1.05 1.05 0 0 1-.35.525L6.475 10.5q.65 1.175 1.412 2.162.763.989 1.613 1.863.9.9 1.95 1.675t2.325 1.475l2.075-2.125q.25-.275.537-.35t.663-.025l1.7.35q.424.1.688.425.262.325.262.75v1.95q0 .45-.312.75-.313.3-.763.3"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "phone-in-call"}) } }